import { Component, Input, inject, OnInit } from "@angular/core";
import { ClockService } from "@app/_services/clock.service";
import { differenceInSeconds, isValid, roundToNearestMinutes } from "date-fns/esm";
import { BehaviorSubject, combineLatest } from "rxjs";
import { distinctUntilChanged, map } from "rxjs/operators";

@Component({
	selector: "tg-record-toolbar-counter",
	templateUrl: "./record-toolbar-counter.component.html",
	styleUrls: ["./record-toolbar-counter.component.scss"],
})
export class RecordToolbarCounterComponent implements OnInit {
	private readonly clock = inject(ClockService);
	constructor() {}

	ngOnInit(): void {}
	private _start = new BehaviorSubject<Date>(null);
	readonly start$ = this._start.asObservable().pipe(distinctUntilChanged());
	get start() {
		return this._start.getValue();
	}
	@Input()
	set start(val: Date) {
		this._start.next(val);
	}

	/** HH / mm parts + blinking separator; null when idle */
	readonly display$ = combineLatest([this.start$, this.clock.now$]).pipe(
		map(([start, now]) => {
			if (start == null) return null;
			const date = roundToNearestMinutes(new Date(start), { nearestTo: 1 });
			if (!isValid(date)) return null;
			const sec = differenceInSeconds(date, now);
			const s = Math.abs(Math.floor(sec));
			const h = Math.floor(s / 3600);
			const m = Math.floor((s % 3600) / 60);
			return {
				hours: h.toString().padStart(2, "0"),
				minutes: m.toString().padStart(2, "0"),
			};
		})
	);
}
